import { useMutation, useQueryClient } from '@tanstack/react-query';
import { removeForwarding } from 'api';
import { toastEmitter } from 'components/Toast';

export default function useRemoveForwarding({ handleSuccess = () => null }) {
  const queryclient = useQueryClient();

  const Request = useMutation({
    mutationFn: removeForwarding,
    mutationKey: ['removeForwarding'],
    onSuccess: (data) => {
      const status = data?.status;
      const responseData = data?.data;
      if (status !== 200) {
        return toastEmitter('error', responseData?.error?.message);
      }
      handleSuccess();
      queryclient.invalidateQueries('getDIDListing');
      toastEmitter('success', responseData?.data?.message);
    },
  });
  return { ...Request };
}
